// Prefixes.jsx
import { Row, Col, Form, Button } from "react-bootstrap";

export default function Prefixes() {
  return (
    <>
      <h5 className="mb-3">Prefixes</h5>

      <div className="section-border">
        <h6>Auto Numbering</h6>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Invoice Prefix</Form.Label>
              <Form.Control placeholder="INV-" />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Employee ID Prefix</Form.Label>
              <Form.Control placeholder="EMP-" />
            </Form.Group>
          </Col>
        </Row>
      </div>

      <div className="text-end">
        <Button variant="light">Cancel</Button>
        <Button className="btn-orange ms-2">Save</Button>
      </div>
    </>
  );
}